const Search = ({ ...props }) => {
    return (
        <svg
            width="18"
            height="20"
            viewBox="0 0 18 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M15.5191 15.2733C13.831 13.7621 11.7542 12.5477 12.2408 12.1315C13.7072 10.8777 14.3581 9.22611 14.2877 6.51892C14.2743 5.58622 14.065 4.6669 13.6736 3.82135C13.2822 2.97579 12.7175 2.2231 12.0166 1.61271C11.3156 1.00232 10.4945 0.548029 9.60672 0.279659C8.719 0.0112893 7.78479 -0.0650885 6.86565 0.0555431C-0.188352 0.420527 -0.701026 7.80162 0.510954 10.7543C1.39156 12.8878 4.66352 15.6343 9.84019 13.942C10.3751 13.8107 11.3575 16.0544 12.8409 17.5774C14.6882 19.4706 16.5512 20.6771 17.6927 19.5874C18.8343 18.4977 16.4989 16.145 15.5191 15.2733ZM5.06672 11.2716C4.57418 11.0251 4.13789 10.6783 3.78553 10.2531C3.43317 9.82804 3.1723 9.33389 3.01967 8.80204C2.7545 7.78527 2.78902 6.71282 3.11889 5.71542C3.33667 5.14683 3.67149 4.63109 4.10149 4.20205C4.53148 3.77302 5.04693 3.44043 5.61377 3.22614C6.18059 3.01186 6.78606 2.92073 7.39039 2.95875C7.99472 2.99677 8.58414 3.16308 9.12005 3.44674C12.8173 5.06685 11.4919 8.81648 10.4822 10.1675C9.86499 10.8658 9.05337 11.3613 8.15274 11.5893C7.2521 11.8173 6.30399 11.7675 5.43189 11.4462C5.30665 11.3884 5.18544 11.3346 5.06672 11.2663V11.2716Z"
                fill="currentColor"
            />
        </svg>
    )
}

export default Search
